import { useState, useEffect, RefObject } from 'react';
import { ERD_DIMENSIONS } from '../../../constants/erd.constant';
import { Dimensions } from '../../../types/erd';

export function useDimensions(containerRef: RefObject<HTMLDivElement | null>): { dimensions: Dimensions; debouncedDimensions: Dimensions } {
  const [dimensions, setDimensions] = useState<Dimensions>({
    width: ERD_DIMENSIONS.DEFAULT_WIDTH,
    height: ERD_DIMENSIONS.DEFAULT_HEIGHT,
  });

  const [debouncedDimensions, setDebouncedDimensions] = useState<Dimensions>({
    width: ERD_DIMENSIONS.DEFAULT_WIDTH,
    height: ERD_DIMENSIONS.DEFAULT_HEIGHT,
  });

  useEffect(() => {
    const updateDimensions = (): void => {
      if (containerRef.current) {
        setDimensions({
          width: containerRef.current.clientWidth,
          height: containerRef.current.clientHeight || 600,
        });
      }
    };
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    return (): void => window.removeEventListener('resize', updateDimensions);
  }, [containerRef]);

  useEffect(() => {
    const timeoutId = setTimeout((): void => {
      setDebouncedDimensions(dimensions);
    }, ERD_DIMENSIONS.DEBOUNCE_DELAY);

    return (): void => clearTimeout(timeoutId);
  }, [dimensions]);

  return { dimensions, debouncedDimensions };
}
